import React from 'react';

import { MODAL_TYPES } from 'Feature/components/app-modals';
import MoldReceivingAddEdit from './mold-receiving-add-edit';

const { MOLDRECEIVING_ADD_EDIT } = MODAL_TYPES;

const MoldReceivingModals = () => {
  return (
      <>
         <MoldReceivingAddEdit modalId={MOLDRECEIVING_ADD_EDIT} />
        
       </>
     );
   };
   

export default MoldReceivingModals